import {createAsyncThunk} from '@reduxjs/toolkit'
import {FetchNoficationsRequest, UpdateNotificationsRequest} from './types'
import {fetchNotificationsUrl, updateNotificationUrl} from '../../api'
import axios, {AxiosError} from 'axios'

export const fetchNotifications = createAsyncThunk(
  'exercices/fetchNotifications',
  async (payload: FetchNoficationsRequest, {rejectWithValue}) => {
    try {
      const res = await axios.get(`${fetchNotificationsUrl}?recipient=${payload.recipient}`)
      return {
        success: true,
        notifications: res.data.notifications,
      }
    } catch (error) {
      const err: any = error as AxiosError
      const message = err.response?.data.fr
      return rejectWithValue({
        success: false,
        error: message || 'message',
      })
    }
  }
)

export const updateNotification = createAsyncThunk(
  'exercices/updateNotification',
  async (payload: UpdateNotificationsRequest, {rejectWithValue}) => {
    try {
      const res = await axios.post(updateNotificationUrl, payload)
      return {
        status: 'success',
        data: res.data,
      }
    } catch (error) {
      const err: any = error as AxiosError
      const message = err.response?.data.fr
      return rejectWithValue({
        success: false,
        error: message || 'message',
      })
    }
  }
)
